const GOOGLE_OAUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth'

export function buildGoogleOAuthUrl(origin: string, clientId: string): string {
  const url = new URL(GOOGLE_OAUTH_URL)
  url.searchParams.set('client_id', clientId)
  url.searchParams.set('redirect_uri', `${origin}/auth/google/callback`)
  url.searchParams.set('response_type', 'code')
  url.searchParams.set('scope', 'openid email profile')
  url.searchParams.set('access_type', 'offline')
  url.searchParams.set('prompt', 'select_account')
  return url.toString()
}
